import DimmerPopup from '../../../components/DimmerPopup';
import { Button, Form, Icon } from '../../../components';

import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { invoke, last, map, max } from 'lodash';

const formatWeight = (declaration, attempt) => {
  if (attempt) {
    const { weight, decision } = attempt;
    return `${!decision.isGoodLift ? '-' : ''}${weight}`;
  } else if (declaration) return `'${declaration.weight}`;
  return '';
};

const parseWeight = (string = '') => {
  if (!string.length) return { type: 'empty' };

  const [type, numberString] = string.startsWith("'")
    ? ['declaration', string.substr(1)]
    : ['attempt', string];

  const number = Number(numberString);
  if (!number || String(number) !== numberString) return { type: 'error' };

  const [weight, props] =
    type === 'attempt'
      ? [Math.abs(number), { isGoodLift: number > 0 }]
      : [number, {}];

  return { type, weight, ...props };
};

class AttemptPopupQuickForm extends Component {
  defaultValue = formatWeight(this.props.declaration, this.props.attempt);
  defaultState = {
    value: this.defaultValue,
    parsed: parseWeight(this.defaultValue),
  };
  state = this.defaultState;

  submit = values => {
    invoke(this.props, 'onSubmit', values);
  };

  onInputFocus = event => {
    const { target } = event;
    const { value } = target;

    if (value.startsWith("'")) target.setSelectionRange(1, value.length);
    else target.select();
  };

  onQuickChange = event => {
    const { value } = event.target;

    this.setState({ value, parsed: parseWeight(value) });
  };

  onFormSubmit = event => {
    event.preventDefault();

    this.submit(this.state.parsed);
  };

  onFormReset = event => {
    event.preventDefault();

    this.setState(this.defaultState);
  };

  decision = isGoodLift => {
    const { weight } = this.state.parsed;
    this.submit({ type: 'decision', weight, isGoodLift });
  };

  onGoodLiftClick = event => {
    event.preventDefault();
    this.decision(true);
  };

  onNoLiftClick = event => {
    event.preventDefault();
    this.decision(false);
  };

  render() {
    const { value, parsed } = this.state;
    const isChanged = value !== this.defaultValue;
    const error = parsed.type === 'error';
    return (
      <Form onSubmit={this.onFormSubmit}>
        <Form.Input
          action
          label="Quick edit"
          value={value}
          error={error}
          pattern="['-]?[1-9][0-9]*"
          onFocus={this.onInputFocus}
          onChange={this.onQuickChange}
          style={{ width: 'calc(2*10ch + 2em)' }}
          autoFocus
          fluid
        >
          <input />
          <Button
            type="button"
            title="Change"
            disabled={!isChanged || error}
            onClick={this.onFormSubmit}
            style={{ width: '25%' }}
            primary
          >
            <Icon name="save" />
          </Button>
          <Button
            type="button"
            title="Reset"
            disabled={!isChanged}
            onClick={this.onFormReset}
            style={{ width: '25%' }}
            secondary
          >
            <Icon name="undo" />
          </Button>
        </Form.Input>
        <Form.Field>
          <label>Decision</label>
          <Button.Group fluid>
            <Button
              type="button"
              icon="check"
              title="Good lift"
              disabled={isChanged}
              onClick={this.onGoodLiftClick}
              color="green"
            />
            <Button
              type="button"
              icon="times"
              title="No lift"
              disabled={isChanged}
              onClick={this.onNoLiftClick}
              color="red"
            />
          </Button.Group>
        </Form.Field>
      </Form>
    );
  }
}

console.warn('TODO: Show all details about attempt');
console.warn('FIXME: When empty, change icon to erase and ask confirm?');
// Decisions: Automatic, Manual, Jury (order = 1, 2, 3)

// TODO: Attach dimmer to Protocol/Table only?
class AttemptPopup extends Component {
  //defaultValue = formatWeight(this.props.value);
  state = { open: false };

  onOpen = () => this.setState({ open: true });
  onClose = () => this.setState({ open: false });

  declaration = values => {
    const { declarations } = this.props;
    const changeNumber = max([-1, ...map(declarations, 'changeNUmber')]) + 1;
    invoke(this.props, 'actions.declaration', {
      type: 'declaration',
      changeNumber,
      ...values,
    });
  };
  decision = values =>
    invoke(this.props, 'actions.decision', {
      type: 'decision',
      ...values,
    });

  clearDeclarations = () => {
    const { declarations } = this.props;
    for (const { changeNumber } of declarations)
      this.declaration({ changeNumber, weight: undefined });
  };
  clearDecision = () => this.decision({ type: 'decision', weight: undefined });

  onQuickFormSubmit = values => {
    const { attempt } = this.props;
    if (values.type === 'decision') {
      this.decision(values);
      this.onClose();
    } else if (values.type === 'declaration') {
      if (attempt) this.clearDecision();
      this.declaration(values);
      this.onClose();
    } else if (values.type === 'empty') {
      if (attempt) this.clearDecision();
      this.clearDeclarations();
      this.onClose();
    }
  };

  render() {
    const { trigger, title, declarations, attempt } = this.props;
    const { open } = this.state;

    return (
      <DimmerPopup
        trigger={cloneElement(trigger)}
        open={open}
        onOpen={this.onOpen}
        onClose={this.onClose}
        on="click"
        position="right center"
        flowing
      >
        <DimmerPopup.Header>{title}</DimmerPopup.Header>
        <DimmerPopup.Content>
          <AttemptPopupQuickForm
            declaration={last(declarations)}
            attempt={attempt}
            onSubmit={this.onQuickFormSubmit}
          />
          {/*<Checkbox label="Show changes" />*/}
        </DimmerPopup.Content>
      </DimmerPopup>
    );
  }
}

AttemptPopup.propTypes = {
  trigger: PropTypes.element.isRequired,
  declarations: PropTypes.array.isRequired,
  attempt: PropTypes.object,
  actions: PropTypes.shape({
    declaration: PropTypes.func.isRequired,
    decision: PropTypes.func.isRequired,
  }).isRequired,
};

export default AttemptPopup;



// WEBPACK FOOTER //
// ./src/terminals/Director/Protocol/AttemptPopup.js